<template>
  <div
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
    class="sidebar"
  >
    <!--
      Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
      Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
    -->
    <div id="style-3" class="sidebar-wrapper">
      <div class="logo">
        <a href="#" class="simple-text">
          <div class="logo-img">
            <img
              v-if="host === 'joshgen.planted.church'"
              :src="joshGenLogo"
              alt="Logo"
            />
            <img v-else :src="plantedLogo" alt="Logo" />
            <!-- <img
              v-if="host === 'app.plantedchurch.net'"
              src="@assets/images/logo.png"
              alt="Logo"
            />
            <img
              v-else-if="host === 'app.planted.network'"
              src="@assets/images/logo.png"
              alt="Logo"
            />
            <img
              v-else-if="host === 'generation.planted.network'"
              src="@assets/images/generation.png"
              alt="Logo"
            />
            <img v-else src="@assets/images/logo.png" alt="Logo" /> -->
          </div>
          <span v-if="host === 'app.plantedchurch.net'">
            Planted Church
          </span>
          <span v-else-if="host === 'app.planted.network'">
            Planted Network
          </span>
          <span v-else-if="host === 'generation.planted.network'">
            Generation Schools
          </span>
          <span v-else>
            {{ title }}
          </span>
        </a>
      </div>
      <slot />
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <NavSidebarLink
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          />
        </slot>
      </ul>
      <NavMovingArrow :move-y="arrowMovePx" />
      <div class="version">v{{ appVersion }}</div>
    </div>
  </div>
</template>

<script>
import PlantedLogo from '../../assets/images/logo.png'
import JoshGenLogo from '../../assets/images/jg_logo_light.png'
import NavMovingArrow from './nav-moving-arrow.vue'
import NavSidebarLink from './nav-sidebar-link.vue'

export default {
  components: { NavMovingArrow, NavSidebarLink },
  props: {
    title: {
      type: String,
      default: 'Planted Beta',
    },
    backgroundColor: {
      type: String,
      default: 'dark',
      validator: (value) => {
        let acceptedValues = ['light', 'dark', 'darkblue']
        return acceptedValues.indexOf(value) !== -1
      },
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = [
          'default',
          'primary',
          'info',
          'success',
          'warning',
          'danger',
        ]
        return acceptedValues.indexOf(value) !== -1
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    }
  },
  data() {
    return {
      appVersion: this.$appVersion,
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
      host: null,
      joshGenLogo: JoshGenLogo,
      plantedLogo: PlantedLogo,
    }
  },
  computed: {
    // ...authComputed,
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex
    },
  },
  mounted() {
    this.$watch('$route', this.findActiveLink, {
      immediate: true,
    })
    this.host = window.location.host
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index
        }
      })
    },
    addLink(link) {
      if (this.$slots.links) {
        const index = this.$slots.links.indexOf(link.$vnode)
        this.links.splice(index, 0, link)
      }
    },
    removeLink(link) {
      const index = this.links.indexOf(link)
      if (index > -1) {
        this.links.splice(index, 1)
      }
    },
  },
}
</script>

<style lang="scss">
.sidebar-wrapper {
  .version {
    position: fixed;
    bottom: 10px;
    left: 20px;
  }
}
</style>
